module.exports = __webpack_public_path__ + "static/media/jumbo_banner_2.95eb21f0.jpg";